// mparle-recently-viewed.js
// Track product-bezoeken in localStorage en rendert "Recent bekeken"-grid via
// Shopify's Section Rendering API (server-side Liquid; output veilig ge-escaped).
(function () {
  const STORAGE_KEY = 'mparle:rv';
  const MAX = 8;
  const DISPLAY_COUNT = 4;

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter((h) => typeof h === 'string' && h.length > 0) : [];
    } catch (_) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX)));
    } catch (_) {
      /* quota / private mode — gewoon negeren */
    }
  }

  // 1. Track huidige product op PDP
  const meta = document.querySelector('meta[name="mp-current-product-handle"]');
  if (meta && meta.content) {
    const handle = meta.content;
    const next = [handle, ...read().filter((h) => h !== handle)];
    write(next);
  }

  // 2. Render het grid wanneer de section op de pagina staat
  const root = document.querySelector('[data-mp-recently-viewed]');
  if (!root) return;

  const exclude = root.dataset.excludeHandle || '';
  const handles = read()
    .filter((h) => h !== exclude)
    .slice(0, DISPLAY_COUNT);

  if (handles.length === 0) return;

  const params = handles.map((h) => `handle[]=${encodeURIComponent(h)}`).join('&');
  const url = `/?section_id=mparle-recently-viewed-render&${params}`;

  fetch(url)
    .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-mp-rv-grid]');
      const placeholder = root.querySelector('[data-mp-rv-grid]');
      if (newGrid && placeholder && newGrid.children.length > 0) {
        placeholder.replaceWith(newGrid);
        root.style.display = '';
      }
    })
    .catch(() => {
      /* netwerk error — section blijft hidden */
    });
})();
